module.exports = __webpack_public_path__ + "static/2-afc553b3531847cba6abee0dcf665eef.png";